import { Flex, Icon, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';

import SectionCard from '../SectionCard';

import BillingFieldGroup from './BillingFieldGroup';
import { FIELD_GROUPS } from './fieldGroups';

import type { InvoicingBilling } from 'api/quote-marketplace';

const InvoicingBillingPanel = ({ billing }: { billing: InvoicingBilling }) => {
  const infoBg = useColorModeValue('#e8f2f8', 'navy.900');
  const accent = useColorModeValue('#24658a', 'blue.200');

  return (
    <Stack spacing="4">
      <Flex
        align="flex-start"
        gap="3"
        bg={infoBg}
        color={accent}
        borderRadius="lg"
        px="4"
        py="3"
        fontSize="sm"
      >
        <Icon as={FiInfo} mt="0.5" flexShrink={0} />
        <Text>
          Fields marked “Not available yet” are still pending from Acturis.
        </Text>
      </Flex>
      {FIELD_GROUPS.map((group) => (
        <SectionCard key={group.title}>
          <BillingFieldGroup group={group} billing={billing} />
        </SectionCard>
      ))}
    </Stack>
  );
};

export default InvoicingBillingPanel;
